<template>
    <section id="ChngPassModal">
        <b-modal
                @hide="onHide"
                id="change-password-modal"
                ref="chngPassModal"
                centered
                hide-header
                hide-footer>
            <div class="change-pass mx-auto d-flex justify-content-center align-items-center position-relative">
                <button
                        @click="$store.commit('TOGGLE_MODAL', ['pass-pop', false])"
                        aria-label="Close"
                        id="modal-close"
                        class="close pr-2">
                            <CloseCross/>
                </button>
                <div class="modal-container-wrap">
                    <div class="text-center">
                        <p class="p3b c22">Change Password</p>
                        <p class="c23 p1n mb-3">Tired of your old password? Change it here.</p>
                        <p v-if="error_text" class="c5 p1n mb-0" >
                            {{error_text}}
                        </p>
                    </div>
                    <md-field>
                        <label class="p1n px-2">Current Password</label>
                        <md-input class="p1n" v-model="currentPassword" type="password"/>
                    </md-field>
                    <EmailInput
                        :on-submit="changePassword"
                        :activ-fields="{password: true, confirmPass: true}"
                        :on-pass-confirmed="onPassConfirmed"
                        :on-confirm-pass="onConfirmPass"/>
                    <button 
                        :class="{'inactive': !currentPassword || !confirmPassword}"
                        @click="changePassword" 
                        class="c16 p2b phiolet_button mt-2">
                            Reset Password
                    </button>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import * as firebase from "firebase";
    import EmailInput from '@/components/EmailPasswordValid/EmailInput.vue' 
    import {CloseCross} from '../components/Icons'
    import { message } from 'ant-design-vue'
    import {auth} from "../firebase";

    export default {
        name: 'ChangePassPop',
        components: {
            EmailInput,
            CloseCross
        },
        data() {
            return {
                password: '',
                currentPassword: '',
                confirmPassword: '',
                error_text: ''
            }
        },
        mounted: function() {
            this.$bvModal.show(`change-password-modal`)
        },
        methods: {
            onHide(evt) {
                this.confirmPassword = null
                this.currentPassword = null
                this.password = null
                this.error_text = null
                setTimeout(() => {
                    this.$store.commit('TOGGLE_MODAL', ['pass-pop', false])
                }, 0)
                this.$store.dispatch('clearErrors')
            },
            reauthenticate: (currPassword) => {
              const user = auth.currentUser;
              let cred = firebase.auth.EmailAuthProvider.credential(user.email, currPassword);
              return user.reauthenticateWithCredential(cred);
            },
            changePassword: function()  {
                this.reauthenticate(this.currentPassword).then(()=>{                    
                    const user = auth.currentUser;
                    let newPassword = this.confirmPassword;
                    user.updatePassword(newPassword)
                        .then(() => {
                            // Update successful.
                            message.success('Password successfully changed!')
                            this.error_text = ''
                            this.$store.commit('TOGGLE_MODAL', ['pass-pop', false])
                            this.$store.commit('TOGGLE_MODAL', ['pass-change', true])

                        }).catch(e => {
                            console.log(e)
                        });
                }).catch((e)=>{
                    // console.log(e)
                    if(e.code === "auth/wrong-password") {
                        this.error_text = 'Wrong Password'
                    }
                });

            },
            onPassConfirmed(val) {
                this.password = val;
            },
            onConfirmPass(val) {
                this.confirmPassword = val;
            }
        }
    }

</script>

<style scoped lang="scss">
.md-field {
    width: 100%;
    min-height: 48px;
    margin: 0px 0 22px;
    padding-top: 8px;
    display: flex;
    position: relative;
    font-family: inherit;

    &.name-required {
        label {
            color: #fa5c7cb3 !important;
        }
        input {
            border: 1px solid #fa5c7cb3 !important;
        }
    }
    div.name-required {
        position: absolute;
        top: 100%;
    }

    &.md-theme-default::after,
    &.md-theme-default::before {
        background-color: transparent;
        content: none !important;
    }

    &.md-focused label,
    &.md-has-value label {
        pointer-events: auto;
        top: 5px;
        opacity: 1;
        font-size: 12px;
        background: #fff;
    }

    .md-input {
        height: 48px !important;
        border: 1px solid #C7C4C4 !important;
        box-sizing: border-box;
        border-radius: 5px;
        padding-left: 10px !important;
    }

    label {
        position: absolute;
        top: 50%;
        left: 11px;
        pointer-events: none;
        transform: translateY(-35%);
        transition: .4s cubic-bezier(.25, .8, .25, 1);
        transition-duration: .3s;
        font-size: 13px;
        line-height: 20px;
        margin: 0;
    }
}
div.change-pass {
    width: 450px;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 5px;

    div.modal-container-wrap {
        width: 325px;
        padding-top: 40px;
        padding-bottom: 20px;

        @media screen and (max-width: 767px) {
            width: 73%
        }

        button {
            width: 100%;
            height: 48px;
            &:first-child {
                background: #F4F4F4;
                border-radius: 5px;
                transition: all 0.2s ease;

                &:hover {
                    box-shadow: 0px 4px 8px #858585;
                }
            }
            &.inactive {
                background: #F4F4F4 !important;
                color: #858585 !important;
                transition: all 0.2s ease;
                &:hover {
                    box-shadow: 0px 4px 8px #858585;
                }
            }
        }
    }
}

  
</style>
